import React from "react"

import {
  InternalRHSCTAContainer,
  Title,
  Excerpt,
  InternalRHSCTAButton,
} from "./style"

const InternalRHSCTA = data => {
  console.log('data:', data)
  return (
    <InternalRHSCTAContainer>
      <Title>{data.data && data.data.title}</Title>
      <Excerpt>{data.data && data.data.excerpt}</Excerpt>
      <InternalRHSCTAButton
        link={data.data && data.data.link}
        label="Read more"
      />
    </InternalRHSCTAContainer>
  )
}

export default InternalRHSCTA
